
import { createAction } from 'typesafe-actions';
import { IPumpingStation } from '../../@types/model/pumpingStation/pumpingStation';

export const pumpingStationSetList = createAction('PUMPINGSTATION_SET_PUMPINGSTATIONS', resolve => (pumpingStations : Array<IPumpingStation>) => resolve(pumpingStations));
export const pumpingStationSetSelected = createAction('PUMPINGSTATION_SET_SELECTED', resolve => (selectedPumpingStation ?: IPumpingStation) => resolve(selectedPumpingStation));
export const pumpingStationSetLoading = createAction('PUMPINGSTATION_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
